import { Controller } from "@hotwired/stimulus"

export default class GlobalSearchController extends Controller {
  static targets = ["searchWrapper", "searchInput", "clearSearch"]

  connect() {
    this.activeSearchWrapperClasses = []
    this.activeInputClasses = []
  }

  focus() {
    this.searchWrapperTarget.classList.add(...this.activeSearchWrapperClasses)
    this.searchInputTarget.classList.add(...this.activeInputClasses)
    this.toggleClearBtn()
  }

  blur() {
    if (this.searchInputTarget.value) return
    this.searchWrapperTarget.classList.remove(
      ...this.activeSearchWrapperClasses
    )
    this.searchInputTarget.classList.remove(...this.activeInputClasses)
    this.toggleClearBtn()
  }

  toggleClearBtn() {
    const isHidden = this.clearSearchTarget.classList.contains("hidden")

    if (isHidden) {
      this.clearSearchTarget.classList.replace("hidden", "block")
    } else {
      this.clearSearchTarget.classList.replace("block", "hidden")
    }
  }

  clear() {
    this.searchInputTarget.value = ""
    this.blur()
    const event = new Event("event-dispatcher:global-search-input", {
      bubbles: true,
    })
    document.dispatchEvent(event)
  }

  clearMobileSearch() {
    const mobileSearchInput = this.searchInputTargets[1]
    mobileSearchInput.value = ""
    const event = new Event("event-dispatcher:global-search-input", {
      bubbles: true,
    })
    document.dispatchEvent(event)
  }
}
